module.exports = __webpack_public_path__ + "static/media/bot_token.f30d5843.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/views/docs/img/bot_token.png
// module id = 972
// module chunks = 0